// Text To Speech
import {TtsPlayerVoice} from "~/libs/interfaces/TtsPlayerVoice"
import {TtsPlayerMode} from "~/libs/interfaces/TtsPlayerMode";


export interface TtsIframeUrlParams {
  id: string
  voice?: TtsPlayerVoice,
  autoplay?: boolean,
  startTime?: number
  site?: string
}

export const useTts = () => {
  const getMode = (): TtsPlayerMode => {
    return useRuntimeConfig().public.tts.mode as TtsPlayerMode
  }
  const getIframeUrl = (
    payload: TtsIframeUrlParams
  ):string|undefined => {
    const runtimeConfig = useRuntimeConfig()
    const url = runtimeConfig.public.tts?.iframeUrl || ''
    const site = runtimeConfig.public.tts?.site || 'uni-fe'
    if (!payload.voice) {
      payload.voice = TtsPlayerVoice.MALE
    }
    if (typeof payload.autoplay === 'undefined') {
      payload.autoplay = runtimeConfig.public.tts?.autoplay || false
    }
    if (!payload.startTime) {
      // start from beginning
      payload.startTime = 0
    }

    return url
      .replace(/%ID%/g, useShortItemId(payload.id) || '')
      .replace(/%VOICE%/g, payload.voice)
      .replace(/%AUTOPLAY%/g, payload.autoplay ? '1' : '0')
      .replace(/%START_TIME%/g, String(payload.startTime))
      .replace(/%SITE%/g, String(site))
  }

  const getEmbedUrl = (
    payload?: TtsIframeUrlParams
  ):string => {
    const runtimeConfig = useRuntimeConfig()
    const id = payload?.id || ""
    const url = runtimeConfig.public.tts?.embedUrl || ''
    const site = runtimeConfig.public.tts?.site || 'uni-fe'
    const voice = payload?.voice || TtsPlayerVoice.MALE
    const autoplay = (typeof payload?.autoplay !== 'undefined') ? payload.autoplay : runtimeConfig.public.tts?.autoplay || false
    const startTime = payload?.startTime || 0

    return url
      .replace(/%ID%/g, useShortItemId(id) || '')
      .replace(/%VOICE%/g, voice)
      .replace(/%AUTOPLAY%/g, autoplay ? '1' : '0')
      .replace(/%START_TIME%/g, String(startTime))
      .replace(/%SITE%/g, String(site))
  }

  const isEnabled = ():boolean => {
    const runtimeConfig = useRuntimeConfig()

    if (!runtimeConfig.public.tts?.enabled) {
      return false
    }

    const mode = getMode()
    switch (mode) {
      case TtsPlayerMode.IFRAME:
        return !!runtimeConfig.public.tts?.iframeUrl;
      case TtsPlayerMode.EMBED:
      default:
        return !!runtimeConfig.public.tts?.embedUrl;

    }
  }

  return {
    isEnabled,
    getIframeUrl,
    getEmbedUrl,
    getMode
  }
}
